import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith('/api') && environment.backendUrl) {
    const baseUrl = environment.backendUrl.replace(/\/$/, '');
    const apiReq = req.clone({
      url: `${baseUrl}${req.url.replace(/^\/api/, '')}`,
    });
    return next(apiReq);
  }

  return next(req);
};
